const DEFAULT_MAX_EDGE = 1600;
const DEFAULT_RESIZE_THRESHOLD_BYTES = 1200 * 1024;
const DEFAULT_JPEG_QUALITY = 0.82;

export async function prepareImageUpload(file, {
  maxEdge = DEFAULT_MAX_EDGE,
  resizeThresholdBytes = DEFAULT_RESIZE_THRESHOLD_BYTES,
  quality = DEFAULT_JPEG_QUALITY,
  outputBaseName = 'pfandpirat-foto',
} = {}) {
  if (!file || !file.type?.startsWith('image/') || file.type === 'image/gif') {
    return file;
  }

  if (Number(file.size || 0) <= resizeThresholdBytes) {
    return file;
  }

  try {
    const imageUrl = URL.createObjectURL(file);
    const image = await new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = imageUrl;
    });

    const width = Number(image.naturalWidth || image.width || 0);
    const height = Number(image.naturalHeight || image.height || 0);
    if (!width || !height) {
      URL.revokeObjectURL(imageUrl);
      return file;
    }

    const scale = Math.min(1, maxEdge / Math.max(width, height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(width * scale));
    canvas.height = Math.max(1, Math.round(height * scale));
    canvas.getContext('2d')?.drawImage(image, 0, 0, canvas.width, canvas.height);
    URL.revokeObjectURL(imageUrl);

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
    if (!blob || blob.size >= file.size) {
      return file;
    }

    const baseName = String(file.name || outputBaseName).replace(/\.[^.]+$/, '');
    return new File([blob], `${baseName}.jpg`, { type: 'image/jpeg', lastModified: Date.now() });
  } catch {
    return file;
  }
}
